module.exports = __webpack_public_path__ + "blissweb-lt.75a5b41146bd86505c7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Lt/blissweb-lt.svg
// module id = 389
// module chunks = 5